module.exports = __webpack_public_path__ + "assets/img/menu_bg_5.e2b31151.png";